import { Flex, Image } from '@mantine/core';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { Colors, Text, Typography } from 'goalsetter-webapp-components';
import {
  Container,
  SecondContainer,
  bottomPaddingStyle,
  breakWordStyle,
  firstSectionContainerStyle,
  fontFamilyStyle,
  gotMoneyContainerStyle,
  gotMoneyTextStyle,
  imageStyle,
  imageWrapperStyle,
  imgStyle,
  innerContainerStyle,
} from './styles';
import { t } from 'i18next';
import Images from 'assets/img/Images';
import ReactPlayer from 'react-player/file';

interface ThirdFlipProps {
  investorFullName?: string;
  description?: string;
  fullVideoURL?: string;
  imageURL?: string;
  whoIsCardFor?: string;
}

export const ThirdFlip: React.FC<ThirdFlipProps> = ({
  description,
  investorFullName,
  fullVideoURL,
  imageURL,
  whoIsCardFor,
}) => {
  const { isMobile } = useMediaQueryGs();

  const buildContentMedia = () => {
    if (imageURL) {
      return (
        <Flex
          justify="center"
          align="center"
          style={imageWrapperStyle}
        >
          <Image
            src={imageURL}
            alt="User uploaded"
            style={imageStyle}
          />
        </Flex>
      );
    } else if (fullVideoURL) {
      return (
        <Flex
          justify="center"
          align="center"
          style={imageWrapperStyle}
        >
          <ReactPlayer
            muted
            controls
            id="video-container"
            url={fullVideoURL}
            width="90%"
            height="auto"
          />
        </Flex>
      );
    }

    return (
      <Flex
        direction="column"
        justify="center"
        align="center"
        gap="15px"
        style={gotMoneyContainerStyle}
      >
        <Image
          src={Images.YOU_GOT_MONEY}
          alt="Img"
          style={imgStyle}
        />
        <Text
          type={Typography.GSH4}
          color={Colors.WHITE}
          style={gotMoneyTextStyle}
        >
          {t('animatedGoalCard.gotMoney')}
        </Text>
      </Flex>
    );
  };

  return (
    <Container>
      <Flex
        justify="center"
        align="center"
        style={innerContainerStyle(isMobile)}
      >
        {buildContentMedia()}
      </Flex>
      <Flex
        justify="center"
        direction={isMobile ? 'column' : 'row'}
        style={firstSectionContainerStyle(isMobile)}
      >
        <SecondContainer>
          <div style={bottomPaddingStyle}>
            <Text
              type={Typography.GSH5}
              style={breakWordStyle(isMobile)}
            >
              {t('animatedGoalCard.goalcardGreeting', {
                name: whoIsCardFor?.toLowerCase(),
              })}
            </Text>
          </div>
          <div style={bottomPaddingStyle}>
            <Text
              type={Typography.GSBODY2}
              style={fontFamilyStyle}
            >
              {description}
            </Text>
          </div>
          <div style={bottomPaddingStyle}>
            <Text
              type={Typography.GSBODY2}
              style={fontFamilyStyle}
            >
              {investorFullName}
            </Text>
          </div>
        </SecondContainer>
      </Flex>
    </Container>
  );
};
